import React, {useRef, useState} from 'react'
import styled, {keyframes} from 'styled-components'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import {StyledFormControl} from 'organization/Obie/Blocks/ProcessForm/Form/RadioOptions'
import {EffectProps} from 'organization/Obie/Blocks/ProcessForm/TypeEffect'
import {resolveOptions} from 'organization/Obie/ObieServiceProvider'

export default function SelectableOptionsList(props: EffectProps) {
  const {isVisible, onComplete, text, updateCompletion} = props
  const [selectedOption, setSelectedOption] = useState<number>(0)
  const optionsList = useRef<string[]>()

  if (!isVisible) {
    return null
  }

  // When an option is picked, we update the selectedOption state so we can show
  // the appropriate radio button. We also update the completion text in a parent
  // component for when user clicks save.
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const {value} = event.target
    const index = Number(value)

    setSelectedOption(index)

    if (!updateCompletion || !optionsList.current) {
      return
    }

    updateCompletion(optionsList.current[index] || '')
  }

  // Ref because we want the resolve list to survive re-renders. No need to do
  // THAT work many times.
  if (!optionsList.current) {
    optionsList.current = resolveOptions(text)
  }

  return (
    <StyledFormControl component="fieldset">
      <RadioGroup
        aria-label="completion-options"
        name={`completion-options`}
        value={selectedOption}
        onChange={handleChange}
      >
        {optionsList.current.map((option, index) => {
          return (
            <SlidingContainer index={index} key={index}>
              <FormControlLabel
                key={index}
                color="primary"
                value={index}
                control={<Radio />}
                label={option}
              />
            </SlidingContainer>
          )
        })}
        {onComplete && onComplete()}
      </RadioGroup>
    </StyledFormControl>
  )
}

const slideIn = keyframes`
  0% {
    right: -100vw;
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    right: 0;
    opacity: 1
  }
`
const SlidingContainer = styled.div<{
  index: number
}>`
  right: -100vw;
  position: relative;
  animation: ${slideIn} 0.5s linear ${(props) => props.index * 0.03}s 1 forwards;
`
